import { useEffect, useMemo, useState } from "react";
import "./App.css";
import axios from "axios";

const API_BASE = "https://front-api.rulereld.com";

function App() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const nativeApp = data?.native;
  const android7App = data?.android7;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE}/api/apps/last-app`);
        setData(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const noteList = useMemo(() => {
    const note = nativeApp?.note;
    if (!note) return [];
    return note
      .split("\r\n")
      .filter((line) => line.trim() !== "")
      .map((item) => item.replace(/^- /, ""));
  }, [nativeApp?.note]);

  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  if (error) {
    // return <div>Error: {error.message}</div>;
  }

  const handleDownload = async () => {
    if (!nativeApp?.id || !nativeApp?.link) {
      console.error("Invalid native data for download");
      return;
    }

    const postUrl = `${API_BASE}/api/apps/downloads-up/${nativeApp.id}`;
    const fileUrl = `${API_BASE}/${nativeApp.link}`;

    try {
      await axios.post(postUrl);

      const anchor = document.createElement("a");
      anchor.href = fileUrl;
      anchor.download = "ruler.apk";
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    } catch (error) {
      console.error("Error during the download process:", error);
    }
  };

  const downloadAndroid7Apk = async () => {
    if (!android7App?.link) {
      console.error("Android7 APK link not found");
      return;
    }

    try {
      if (android7App?.id) {
        await axios.post(`${API_BASE}/api/apps/downloads-up/${android7App.id}`);
      }
    } catch (e) {
      console.warn("Android7 downloads-up failed:", e);
    }

    const fileUrl = `${API_BASE}/${android7App.link}`;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "ruler-android7.apk";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="card">
      <img src="/rulereld.svg" className="app-icon" />

      <h2 className="version-text">App version: {nativeApp?.appVersion}</h2>

      <div className="section">
        <h3 className="section-title">What’s new</h3>
        <ul className="feature-list">
          {noteList.map((line, index) => (
            <li key={index}>{line}</li>
          ))}
        </ul>
      </div>

      <div className="btn-border">
        <button className="primary-btn" onClick={handleDownload}>
          Download App
        </button>
      </div>

      <p className="note-text">
        For devices running <strong>Android 7</strong> or below, a compatible
        version of the app is available via the button below.
      </p>

      <button className="secondary-btn" onClick={downloadAndroid7Apk}>
        Download App
      </button>
    </div>
  );
}

export default App;
